import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ESolicitacaoConsultaModalidade, IConsulta } from 'src/app/pages/consultas/data/consultas';
import { AgendaService } from '../../services/agenda.service';

@Component({
  selector: 'app-proximas-consultas-dia',
  templateUrl: './proximas-consultas-dia.component.html',
  styleUrls: ['./proximas-consultas-dia.component.scss']
})
export class ProximasConsultasDiaComponent implements OnInit, OnDestroy {
  @Input() consulta!: IConsulta;
  @Output() entrarConsultaChange = new EventEmitter<Date>();

  dataFimConsulta!: Date;
  statusClass!: string;
  isAppointmentNow: boolean = false;
  
  interval: any;

  constructor(private agendaService: AgendaService) {}

  ngOnInit() {
    this.dataFimConsulta = new Date(this.consulta.appointmentDate);
    this.dataFimConsulta.setMinutes(this.dataFimConsulta.getMinutes() + this.consulta.duration);
    this.statusClass = this.agendaService.getClassByStatus(this.consulta.status);

    this.isAppointmentNow = this.checkIfAppointmentIsNow();
    this.interval = setInterval(() => {
      this.isAppointmentNow = this.checkIfAppointmentIsNow();
    }, 1000 * 10);
  }

  ngOnDestroy(): void {
    clearInterval(this.interval);
  }

  checkIfAppointmentIsNow() {
    return this.agendaService.getIsAppointmentDateNow(new Date(this.consulta.appointmentDate));
  }

  getBackgroundClass() {
    return this.isAppointmentNow ? ' bg-chathams-blue border-chathams-blue-700 text-white' : ' bg-white';
  }

  getIcon() {
    return (
      (this.agendaService.getIconByModality(this.consulta.modality)) +
      (this.isAppointmentNow ? '' : '_dark')
    );
  }

  getName(){
    const name = this.consulta.employee?.name ?? ' ';
    return this.isAppointmentNow ? name.split(' ')[0] : name; 
  }

  isAppointmentOnline(){
    return this.consulta.modality === ESolicitacaoConsultaModalidade.Telemedicina;
  }

  entrarConsulta(){
    this.entrarConsultaChange.emit(new Date(this.consulta.appointmentDate));
  }
}
